module.exports = __webpack_public_path__ + "imgs/share-wechat@2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/share-wechat@2x.png
// module id = 232
// module chunks = 93